import * as yup from "yup";

const achievementAwardSchema = yup.object({
    description: yup.string().trim().required("Description is required."),

    awardDate: yup
        .string()
        .nullable()
        .test(
            "not-in-future",
            "Award date cannot be in the future.",
            (value) => {
                if (!value) {
                    return true;
                }

                return new Date(value) <= new Date();
            }
        )
        .required("Award date is required.")
});

export default achievementAwardSchema;
